// assets/ce-media-filter.js — mostra na galeria da PDP só as fotos da cor escolhida.
// Regra: o texto alternativo da foto que contém o nome da cor manda; sem alt, as fotos enviadas
// no mesmo lote (ids próximos) da foto marcada em uma variante recebem a cor dela.
// Fotos sem grupo ficam sempre visíveis. Com uma cor só (ou sem grupos), não faz nada.
(function () {
  const picker = document.querySelector('variant-radios, variant-selects');
  const mainWrap = document.querySelector('.js-media-list .swiper-wrapper');
  const subWrap = document.querySelector('.js-media-sublist .swiper-wrapper');
  if (!picker || !mainWrap) return;

  const mediaId = (el) => String(el.dataset.mediaId || el.dataset.mediaSubId || '').split('-').pop();
  const norm = (s) => String(s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().trim();

  fetch(`${location.pathname}.js`, { headers: { Accept: 'application/json' } })
    .then((r) => r.json())
    .then((product) => {
      const colorIdx = product.options.findIndex((o) => /^(cor|color|colour|cores)$/i.test(norm(o.name)));
      if (colorIdx < 0 || !product.media || product.media.length < 2) return;
      const colors = [...new Set(product.variants.map((v) => v.options[colorIdx]))];
      if (colors.length < 2) return;

      // id da mídia destacada → cor
      const featuredColor = new Map();
      product.variants.forEach((v) => { if (v.featured_media && !featuredColor.has(v.featured_media.id)) featuredColor.set(v.featured_media.id, v.options[colorIdx]); });

      // grupo de cada mídia: alt com o nome da cor manda; senão, lote de upload (ids próximos)
      // que contenha a foto marcada de uma variante recebe a cor dela
      const group = new Map();
      const sorted = product.media.map((m) => m.id).sort((a, b) => a - b);
      const GAP = 10000000; // ids dentro de um mesmo envio ficam a menos disso um do outro
      let cluster = [];
      const clusters = [];
      sorted.forEach((id, i) => { if (i && id - sorted[i - 1] > GAP) { clusters.push(cluster); cluster = []; } cluster.push(id); });
      if (cluster.length) clusters.push(cluster);
      clusters.forEach((ids) => {
        const found = [...new Set(ids.map((id) => featuredColor.get(id)).filter(Boolean))];
        const color = found.length === 1 ? found[0] : null;
        ids.forEach((id) => group.set(id, color));
      });
      product.media.forEach((m) => {
        const byAlt = colors.find((c) => m.alt && norm(m.alt).includes(norm(c)));
        if (byAlt) group.set(m.id, byAlt);
      });
      const grouped = [...group.values()].filter(Boolean);
      if (new Set(grouped).size < 2) return;

      const order = product.media.map((m) => String(m.id));
      const collect = (wrap) => {
        const byId = new Map();
        [...wrap.children].forEach((el) => byId.set(mediaId(el), el));
        return byId;
      };
      const mainById = collect(mainWrap);
      const subById = subWrap ? collect(subWrap) : null;

      const currentColor = () => {
        const fieldsets = picker.querySelectorAll('fieldset');
        if (fieldsets.length) { const i = fieldsets[colorIdx]?.querySelector('input:checked'); return i ? i.value : null; }
        const selects = picker.querySelectorAll('select');
        return selects[colorIdx] ? selects[colorIdx].value : null;
      };

      const rebuild = (wrap, byId, color, featuredId) => {
        const visible = (id) => { const g = group.get(Number(id)); return !g || !color || g === color; };
        const ids = [featuredId, ...order.filter((id) => id !== featuredId)].filter((id) => id && byId.has(id) && visible(id));
        wrap.replaceChildren(...ids.map((id) => byId.get(id)));
      };

      const apply = () => {
        const color = currentColor();
        const vid = Number(new URL(location.href).searchParams.get('variant'));
        const variant = product.variants.find((v) => v.id === vid);
        const featuredId = variant && variant.featured_media ? String(variant.featured_media.id) : (mainWrap.firstElementChild ? mediaId(mainWrap.firstElementChild) : null);
        const mainEl = mainWrap.closest('.js-media-list'), subEl = subWrap && subWrap.closest('.js-media-sublist');
        if (mainEl && mainEl.swiper) mainEl.swiper.destroy(true, true);
        if (subEl && subEl.swiper) subEl.swiper.destroy(true, true);
        rebuild(mainWrap, mainById, color, featuredId);
        if (subWrap) rebuild(subWrap, subById, color, featuredId);
        if (typeof subSliderInit === 'function' && subEl) subSliderInit();
        if (typeof sliderInit === 'function') sliderInit();
      };

      // ao trocar variante: depois do handler nativo (que recoloca a foto da variante na frente)
      document.addEventListener('change', (e) => { if (picker.contains(e.target)) setTimeout(apply, 0); });
      const start = () => { if (mainWrap.closest('.js-media-list').swiper) apply(); else setTimeout(start, 150); };
      start();
    })
    .catch((err) => console.warn('ce-media-filter: sem dados do produto', err));
})();
